import { render, staticRenderFns } from "./HomePageINT.vue?vue&type=template&id=53c465af&scoped=true"
import script from "./HomePageINT.vue?vue&type=script&lang=js"
export * from "./HomePageINT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c465af",
  null
  
)

export default component.exports